import {
    STOP_AUDIO,
    PLAY_AUDIO,
    NARRATE_START,
    NARRATE_RESET,
    PAUSE_AUDIO,
    RESUME_AUDIO,
    SET_CAPTION,
} from './audioActions';

import { SET_TRC_CONTENT } from '../../trc/trcActions';

export const defaultState = {
    isReadyToPlay: false,
    isPaused: false,
    isReadyToNarrate: false,
    onPlayCallback: null,
    onEndCallback: null,
    audioTracks: [],
    caption: '',
};

const audioReducer = (state = defaultState, action) => {
    switch (action.type) {
        case PLAY_AUDIO:
            if (!state.isReadyToPlay) {
                return {
                    ...state,
                    audioTracks: action.audioTracks,
                    isReadyToPlay: true,
                    isPaused: false,
                    delay: action.delay,
                    onPlayCallback: action.onPlayCallback,
                    onEndCallback: action.onEndCallback,
                };
            }
            return state;
        case STOP_AUDIO:
            return {
                ...state,
                isReadyToPlay: false,
                audioTracks: [],
            };
        case PAUSE_AUDIO:
            return {
                ...state,
                isReadyToPlay: false,
                isPaused: true,
            };
        case RESUME_AUDIO:
            return {
                ...state,
                isReadyToPlay: true,
                isPaused: false,
            };
        case NARRATE_START:
            return {
                ...state,
                isReadyToNarrate: true,
            };
        case NARRATE_RESET:
            return {
                ...state,
                isReadyToNarrate: false,
            };
        case SET_TRC_CONTENT:
            return {
                ...state,
                caption: action.content.caption,
            };
        case SET_CAPTION:
            return {
                ...state,
                caption: action.payload,
            };
        default:
            return state;
    }
};

export default audioReducer;
